// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero-module--hero--qAaQF","heading":"Hero-module--heading--1Ke2O","lead":"Hero-module--lead--FMitE"};